<template>
  <div class="service-rate">
    <el-rate v-model="score" disabled show-score text-color="#666" :colors="['#d0011b', '#d0011b', '#d0011b']" disabled-void-color="#aaa"></el-rate>
    <span>评分人次：{{totalScoreNum}}</span>
  </div>
</template>

<script>
export default {
  props: {
    score: {
      type: Number,
      default: 0,
    },
    totalScoreNum: {
      type: Number,
      default: 0,
    },
  },
}
</script>

<style lang="scss" scoped>
.service-rate{
  color: #666;
  display: flex;
  text-align: center;
  align-items: center;
  span{
    padding-left: 20px;
    padding-bottom: 2px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/ServiceRate.vue